import React from 'react'

export const AddPatientSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="125"
      height="117"
      viewBox="0 0 125 117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M62.4564 57.6743C78.3439 57.6743 91.2233 44.795 91.2233 28.9075C91.2233 13.02 78.3439 0.140625 62.4564 0.140625C46.5689 0.140625 33.6896 13.02 33.6896 28.9075C33.6896 44.795 46.5689 57.6743 62.4564 57.6743ZM47.9956 61.1004C44.6189 59.4348 40.7262 58.3422 37.2846 59.8692C17.0121 68.8638 2.45001 88.3898 0.541259 111.504C0.305477 114.36 2.65072 116.687 5.5157 116.687H119.397C122.262 116.687 124.607 114.36 124.371 111.504C122.463 88.3898 107.901 68.8638 87.6281 59.8692C84.1866 58.3422 80.2983 59.4383 76.9294 61.1195C72.7187 63.2209 67.8414 64.0192 62.5752 64.0192C57.2931 64.0192 52.2848 63.2161 47.9956 61.1004ZM77.3681 96.7621C78.5141 96.7621 79.4431 97.6911 79.4431 98.8371V105.808C79.4431 106.954 80.3721 107.883 81.5181 107.883H87.7431C88.8891 107.883 89.8181 106.954 89.8181 105.808L89.8181 98.8369C89.8181 97.6909 90.7471 96.7619 91.8931 96.7619L101.089 96.7618C102.235 96.7617 103.164 95.8327 103.164 94.6867L103.164 88.4617C103.164 87.3158 102.235 86.3867 101.089 86.3868L91.8931 86.3869C90.7471 86.3869 89.8181 85.4579 89.8181 84.3119V77.342C89.8181 76.196 88.8891 75.267 87.7431 75.267H81.5181C80.3721 75.267 79.4431 76.196 79.4431 77.342V84.3121C79.4431 85.4581 78.5141 86.3871 77.3681 86.3871L68.1719 86.3873C67.0259 86.3873 66.0969 87.3163 66.097 88.4623L66.097 94.6873C66.0971 95.8333 67.0261 96.7623 68.1721 96.7623L77.3681 96.7621Z"
        fill="url(#paint0_linear_1871:268387)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1871:268387"
          x1="62.4564"
          y1="0.140625"
          x2="62.4564"
          y2="116.687"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#9299BE" />
          <stop offset="1" stop-color="#3E4685" />
        </linearGradient>
      </defs>
    </svg>
  )
}
